module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cloudAccountCopiesTable.customerName":"Customer Name","cloudAccountCopiesTable.sharedCloudAccountName":"Shared Cloud Connection Name","cloudAccountCopiesTable.markupPercentage":"Markup Percentage","cloudAccountCopiesTable.tagAllocations":"Tags"}}')
  delete Component.options._Ctor
}
